
import { createRoot } from 'react-dom/client';
import '@oliasoft-open-source/react-ui-library/dist/global.css';
import 'src/client/sentry/sentry';
import App from './app';
import { reactErrorHandler } from '@sentry/react';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find root element');
}

const sentryErrorHandlers = {
  // https://docs.sentry.io/platforms/javascript/guides/react/#capture-react-errors-react-19
  // When an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: reactErrorHandler(), // When React catches an error in an ErrorBoundary
  onRecoverableError: reactErrorHandler(), // When React automatically recovers from errors
}

const root = createRoot(container, sentryErrorHandlers);

root.render(
  <App />
);
